export default __webpack_public_path__ + "static/media/empty_cms.1d8d036f.png";